export const LIBRARIES = [
  { label: '=== Bokeh.js ===', disabled: true, value: 'BOKEH_JS' },
  { label: 'Bokeh v 0.12.5', disabled: false, value: 'https://cdnjs.cloudflare.com/ajax/libs/bokeh/0.12.5/bokeh.js' },
  { label: 'Bokeh api v 0.12.5', disabled: false, value: 'https://cdnjs.cloudflare.com/ajax/libs/bokeh/0.12.5/bokeh-api.js' },
  { label: 'Bokeh v 0.12.7', disabled: false, value: 'https://cdnjs.cloudflare.com/ajax/libs/bokeh/0.12.7/bokeh.js' },
  { label: 'Bokeh api v 0.12.7', disabled: false, value: 'https://cdnjs.cloudflare.com/ajax/libs/bokeh/0.12.7/bokeh-api.js' },
  { label: '=== Bootstrap ===', disabled: true, value: 'BOOTSTRAP' },
  { label: 'Bootstrap.js v 3.3.2', disabled: false, value: 'https://maxcdn.bootstrapcdn.com/bootstrap/3.3.2/js/bootstrap.min.js' },

  { label: '=== C3 ===', disabled: true, value: 'C3_JS' },
  { label: 'C3.js v0.4.15', disabled: false, value: 'https://cdnjs.cloudflare.com/ajax/libs/c3/0.4.15/c3.js' },
  { label: '=== Chart.js ===', disabled: true, value: 'TITLE_CHART_JS' },
  { label: 'Chart.js v2.6.0', disabled: false, value: 'https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.7.0/Chart.bundle.js' },


  { label: '=== Crossfilter ===', disabled: true, value: 'CROSSFILTER_JS' },
  { label: 'Crossfilter v1.3.12', disabled: false, value: 'https://cdnjs.cloudflare.com/ajax/libs/crossfilter/1.3.12/crossfilter.min.js' },


  { label: '=== D3.js ===', disabled: true, value: 'TITLE_D3' },
  { label: 'D3 v2', disabled: false, value: 'https://d3js.org/d3.v2.min.js' },
  { label: 'D3 v3', disabled: false, value: 'https://d3js.org/d3.v3.min.js' },
  { label: 'D3 v4', disabled: false, value: 'https://d3js.org/d3.v4.min.js' },

  { label: '=== D3 Annotations ===', disabled: true, value: 'D3_ANNOTATIONS' },
  { label: 'D3-Annotations v1.12.1', disabled: false, value: 'https://cdnjs.cloudflare.com/ajax/libs/d3-annotation/1.12.1/d3-annotation.min.js' },



  { label: '=== DC.js ===', disabled: true, value: 'DC_JS' },
  { label: 'DC v2.1.8', disabled: false, value: 'https://cdnjs.cloudflare.com/ajax/libs/dc/2.1.8/dc.min.js' },


  { label: '=== D3 Topo JSON ===', disabled: true, value: 'TOPO_JSON' },
  { label: 'TopoJson v1', disabled: false, value: 'https://d3js.org/topojson.v1.min.js' },
  { label: '=== Datamaps ===', disabled: true, value: 'DATAMAPS' },
  { label: 'Datamaps world', disabled: false, value: 'https://datamaps.github.io/scripts/datamaps.world.min.js' },
  { label: 'Datamaps world Hi-res', disabled: false, value: 'https://rawgit.com/markmarkoh/datamaps/master/dist/datamaps.world.hires.js' },
  { label: 'Datamaps USA', disabled: false, value: 'https://datamaps.github.io/scripts/datamaps.usa.min.js' },
  { label: 'Datamaps Afghanistan', disabled: false, value: 'https://cdnjs.cloudflare.com/ajax/libs/datamaps/0.5.8/datamaps.afg.js' },
  { label: 'Datamaps Bhutan', disabled: false, value: 'https://cdnjs.cloudflare.com/ajax/libs/datamaps/0.5.8/datamaps.btn.js' },
  { label: 'Datamaps Brittain', disabled: false, value: 'https://cdnjs.cloudflare.com/ajax/libs/datamaps/0.5.8/datamaps.gbr.js' },
  { label: 'Datamaps France', disabled: false, value: 'https://cdnjs.cloudflare.com/ajax/libs/datamaps/0.5.8/datamaps.fra.js' },
  { label: 'Datamaps Germany', disabled: false, value: 'https://cdnjs.cloudflare.com/ajax/libs/datamaps/0.5.8/datamaps.deu.js' },
  { label: 'Datamaps India', disabled: false, value: 'https://cdnjs.cloudflare.com/ajax/libs/datamaps/0.5.8/datamaps.ind.js' },
  { label: 'Datamaps Netherlands', disabled: false, value: 'https://cdnjs.cloudflare.com/ajax/libs/datamaps/0.5.8/datamaps.nld.js' },
  { label: 'Datamaps None', disabled: false, value: 'https://rawgithub.com/markmarkoh/datamaps/master/dist/datamaps.none.min.js' },
  { label: '=== Dimple ===', disabled: true, value: 'DIMPLE' },
  { label: 'Dimple v2.0.0', disabled: false, value: 'https://cdnjs.cloudflare.com/ajax/libs/dimple/2.0.0/dimple.latest.min.js' },
  { label: 'Dimple v2.3.0', disabled: false, value: 'https://cdnjs.cloudflare.com/ajax/libs/dimple/2.3.0/dimple.latest.min.js' },


  { label: '=== FileSaver js ===', disabled: true, value: 'FILESAVER_JS' },
  { label: 'Filesaver v1.3.3', disabled: false, value: 'https://cdnjs.cloudflare.com/ajax/libs/FileSaver.js/1.3.3/FileSaver.min.js' },




  { label: '=== Frappe Gantt ===', disabled: true, value: 'FRAPPE_GANTT' },
  { label: 'Frappe Gantt v0.0.6', disabled: false, value: 'https://cdn.jsdelivr.net/npm/frappe-gantt@0.0.6/dist/frappe-gantt.min.js' },


  { label: '=== Geo Projection ===', disabled: true, value: 'GEO_PROJECTION' },
  { label: 'Geoprojection v0', disabled: false, value: 'https://d3js.org/d3.geo.projection.v0.min.js' },
  { label: '=== HightCharts ===', disabled: true, value: 'HIGH_CHARTS' },
  { label: 'Highcharts', disabled: false, value: 'https://code.highcharts.com/highcharts.js' },
  { label: 'Highcharts More', disabled: false, value: 'https://code.highcharts.com/highcharts-more.js' },
  { label: '=== JQuery ===', disabled: true, value: 'JQUERY' },
  { label: 'Jquery 2.1.3', disabled: false, value: 'https://cdnjs.cloudflare.com/ajax/libs/jquery/2.1.3/jquery.js' },
  { label: 'Jquery 1.11.1', disabled: false, value: 'https://ajax.googleapis.com/ajax/libs/jquery/1.11.1/jquery.min.js' },
  { label: '=== Metrics Graphics ===', disabled: true, value: 'METRICS_GRAPHICS' },
  { label: 'MetricsGraphics v 2.11.0', disabled: false, value: 'https://cdnjs.cloudflare.com/ajax/libs/metrics-graphics/2.11.0/metricsgraphics.js' },
  { label: '=== Mo.js ===', disabled: true, value: 'MO_JS' },
  { label: 'Mo v0.288.1', disabled: false, value: 'https://cdn.jsdelivr.net/mojs/0.288.1/mo.min.js' },
  { label: '=== Moment.js ===', disabled: true, value: 'TITLE_MOMENT' },
  { label: 'Moment v2.18.1', disabled: false, value: 'https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.18.1/moment.js' },
  { label: '=== Plotly ===', disabled: true, value: 'PLOTLY' },
  { label: 'Plotly v1.30.0', disabled: false, value: 'https://cdn.plot.ly/plotly-1.30.0.min.js' },
  { label: '=== Snap SVG ===', disabled: true, value: 'SNAP_SVG' },
  { label: 'Snap.svg v0.5.1', disabled: false, value: 'https://cdnjs.cloudflare.com/ajax/libs/snap.svg/0.5.1/snap.svg.js' },


];

export function labelToValue(label) {
  return LIBRARIES.find(l => l.label === label).value
}

export function labelsToLibraries(labels) {
  return typeof labels === "undefined" ? [] :
    LIBRARIES.filter(function(library) {
      return labels.includes(library.label)
    })
}

export function labelsToLibraryValues(labels) {
  return typeof labels === "undefined" ? [] :
    LIBRARIES.filter(function(lib) {
      return labels.includes(lib.label)
    }).map(function(l) {
      return l.value;
    })
}

// export const libs = typeof nextProps.envelope.libraries === "undefined" ? [] :
//   LIBRARIES.filter(function(lib) {
//     return nextProps.envelope.libraries.includes(lib.label)
//   })



// WEBPACK FOOTER //
// ./src/helpers/libraryHelpers.js